import PropTypes from 'prop-types';
import React from 'react';
import { ButtonGroup, Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import Button from '../../../../../shared/components/Button';
import OauthButton from '../../../../../shared/components/OauthButton/OauthButton';
import { useSelector } from 'react-redux';

const YouTubeError = ({
  onRequestClose,
}) => {
  const { t } = useTranslation();
  const testFlow = useSelector(state => state.config.test);

  return <div>

    <h3 className='mb-4'>
      {t('influencers.pages.campaign.apply_side_pane.youtube_connect.error')}
    </h3>

    <div className="text-2 mb-3">
      {t('influencers.pages.campaign.apply_side_pane.youtube_connect.error_desc')}
    </div>


    <hr className='my-6' />
    <Row className='justify-content-end'>
      <Col className="col-auto">
        <ButtonGroup className="non-adaptable">
          <Button
            variant="secondary"
            type="button"
            onClick={onRequestClose}>
            {t('influencers.common.cancel')}
          </Button>
          {
            testFlow.includes('fb_optional')
              ? <Button
                variant='primary'
                onClick={() => {
                  const { origin, pathname } = window.location;
                  const queryParams = new URLSearchParams({
                    'youtube_oauth_callback': 'success',
                    'test_flow': `yt,yt_success`
                  });
                  window.location.replace(`${origin}${pathname}?${queryParams.toString()}`);
                }}>
                {t('influencers.common.connect')}
              </Button>
              : <OauthButton platform="youtube_publication"
                text={t('influencers.pages.campaign.apply_side_pane.youtube_connect.try_again')} />
          }
        </ButtonGroup>
      </Col>
    </Row>
  </div>;
};

YouTubeError.propTypes = {
  onRequestClose: PropTypes.func.isRequired,
};
export default YouTubeError;